/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_TRAVEL_INTERRUPTION_STATE,
  RESET_TRAVEL_DELAY_STATE,
  RESET_EUROPEAN_UNION_STATE,
  RESET_MEDICAL_EXPENSES_STATE,
  RESET_DENTAL_EXPENSES_STATE,
  RESET_FUNAREL_EXPENSES_STATE,
  RESET_HOSPITALISED_STATE,
  RESET_ACCOMPANYING_PERSON_HOSPITALISED_STATE,
  RESET_EXPENSES_ARISING_FROM_TERRORISM_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES1_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES2_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES3_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES4_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES5_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES6_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES7_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES8_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES9_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES10_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES11_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES12_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES13_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES14_STATE,
  RESET_THE_DEATH_CAUSED_BY_AN_INJURY_STATE,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function nextSlide(errors) {
  return {
    type: NEXT,
    errors,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function resetFormEuropeanUnionData() {
  return {
    type: RESET_EUROPEAN_UNION_STATE,
  };
}

export function resetFormTravelInterruption() {
  return {
    type: RESET_TRAVEL_INTERRUPTION_STATE,
  };
}
export function resetFormTravelDelay() {
  return {
    type: RESET_TRAVEL_DELAY_STATE,
  };
}

export function resetFormMedicalExpenses() {
  return {
    type: RESET_MEDICAL_EXPENSES_STATE,
  };
}

export function resetFormDentalExpenses() {
  return {
    type: RESET_DENTAL_EXPENSES_STATE,
  };
}

export function resetFormFunarelExpenses() {
  return {
    type: RESET_FUNAREL_EXPENSES_STATE,
  };
}

export function resetFormHospitalised() {
  return {
    type: RESET_HOSPITALISED_STATE,
  };
}

export function resetFormAccompanyingPersonHospitalised() {
  return {
    type: RESET_ACCOMPANYING_PERSON_HOSPITALISED_STATE,
  };
}

export function resetFormTheDeathCausedByAnInjury() {
  return {
    type: RESET_THE_DEATH_CAUSED_BY_AN_INJURY_STATE,
  };
}

export function resetFormExpensesArisingFromTerrorism() {
  return {
    type: RESET_EXPENSES_ARISING_FROM_TERRORISM_STATE,
  };
}

export function resetFormOpticalTreatment() {
  return {
    type: RESET_MEDICAL_HOSPITAL_EXPENSES1_STATE,
  };
}

export function resetFormAncillaryServices() {
  return {
    type: RESET_MEDICAL_HOSPITAL_EXPENSES2_STATE,
  };
}

export function resetFormMentalHealth() {
  return {
    type: RESET_MEDICAL_HOSPITAL_EXPENSES3_STATE,
  };
}

export function resetFormSexualHealth() {
  return {
    type: RESET_MEDICAL_HOSPITAL_EXPENSES4_STATE,
  };
}

export function resetFormExtraTravelAndAccommodation() {
  return {
    type: RESET_MEDICAL_HOSPITAL_EXPENSES5_STATE,
  };
}

export function resetFormSearchAndRescue() {
  return {
    type: RESET_MEDICAL_HOSPITAL_EXPENSES6_STATE,
  };
}

export function resetFormUrgentCareOutOfHoursvisits() {
  return {
    type: RESET_MEDICAL_HOSPITAL_EXPENSES7_STATE,
  };
}

export function resetFormPrescriptions() {
  return {
    type: RESET_MEDICAL_HOSPITAL_EXPENSES8_STATE,
  };
}

export function resetFormGPVisits() {
  return {
    type: RESET_MEDICAL_HOSPITAL_EXPENSES9_STATE,
  };
}

export function resetFormOtherMedicalExpenses() {
  return {
    type: RESET_MEDICAL_HOSPITAL_EXPENSES10_STATE,
  };
}


// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.MedicalAndEvacuation/actions.js